import React, { useContext } from "react";
import { PlusIcon } from "~/assets/svg/MathIcon";
import QuestionCardList from "./QuestionCardList";
import { ApplyContext } from "~/pages/applyFormMange/ApplyRegContext";
import { useTranslation } from "react-i18next";

const QnaForm = () => {
	const { t } = useTranslation();
	const { addQuestion } = useContext(ApplyContext);
	return (
		<div className="apply-info-questions">
			<div className="apply-form-head">
				<h3>FAQ</h3>
				<button className="dashed-btn plus-btn" onClick={() => addQuestion()}>
					<PlusIcon />
					{t("common.commonWord.button.add")}
				</button>
			</div>
			<QuestionCardList />
		</div>
	);
};

export default QnaForm;
